$(document).ready(function() {
    // Init Modal
    var flagContentModal = $('.flag-content').modal({
        bgClose : false,
        width : 'auto-width',
        accept : function() {
            flagContentModal.data('qg_modal').closeModal();

            //create post string
            var postString = buildPostString('#flag-content-modal', null, true);
            postString += '&url='+encodeURIComponent(window.location.pathname);

            $.fn.qpost({
                url : url('flag_content',[$('input[name="form"]').val()]),
                csrf : true,
                data : postString,
                success : function(data) {
                    if (data.success) {
                        Message.target = '.event-content';
                        Message.post('This page has been flagged', 'success');
                    } else {
                        Message.target = '.event-content';
                        var errors = (data.errors) ? data.errors : 'We were not able to flag this page. Please try again.';
                        Message.post(errors, 'error');
                    }
                },
                failure : function() {
                    Message.target = '.event-content';
                    Message.post('We were not able to flag this page. Please try again.', 'error');
                },
            });
        },
        decline : function() {
            flagContentModal.data('qg_modal').closeModal();
        }
    });
});